import React from 'react';

import { formatPlate } from './format';

// Placa em texto: a informacao importa, sem imagem de placa (regra clean).
export default function Plate({ value }) {
  return <span className='gs-plate-text'>{formatPlate(value)}</span>;
}
